import type { ReactNode } from "react"
import { Link } from "@inertiajs/react"
import { IconChevronLeft } from "@tabler/icons-react"
import { Button } from "@/components/ui/button"

interface MobileTopBarProps {
  title: string
  backTo?: string
  action?: ReactNode
}

export function MobileTopBar({ title, backTo, action }: MobileTopBarProps) {
  return (
    <header className="sticky top-0 z-40 flex h-12 items-center gap-2 border-b bg-background/95 pl-3 pr-3 backdrop-blur supports-[backdrop-filter]:bg-background/80">
      {backTo && (
        <Button
          asChild
          variant="ghost"
          size="icon-touch"
          className="-ml-2"
          aria-label="Go back"
        >
          <Link href={backTo} prefetch="hover">
            <IconChevronLeft className="size-5" />
          </Link>
        </Button>
      )}
      <h1 className="flex-1 truncate text-base font-semibold">{title}</h1>
      {action && <div className="flex shrink-0 items-center">{action}</div>}
    </header>
  )
}
